/* globals brandColor */

// Custom favicon per community

export default class Favicon {
  constructor() {
    const canvas = document.createElement('canvas');

    if (canvas.getContext) {
      // If we already generated the favicon, simply append it again to the <head>
      if (typeof window._faviconLink !== 'undefined') {
        document.head.appendChild(window._faviconLink);
        return;
      }

      canvas.height = 32;
      canvas.width = canvas.height;

      const context = canvas.getContext('2d');
      context.fillStyle = window.brandColor;
      context.fillRect(2, 2, 28, 28);

      const img = document.createElement('img');
      img.onload = function () {
        context.drawImage(img, 0, 0);

        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = canvas.toDataURL('image/png');
        document.head.appendChild(link);

        window._faviconLink = link;
      };
      img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAA' +
        'ArUlEQVR4Ae3WAQbDQBCF4YUcIOhdChRQUFh6m6CAgoJeIpCC3CFASk8RUIFCEq8PAxNrowyU+fgh' +
        'JjzAhi3OOQAN+7CZvdguc1uyJ5vkn8ZiwNohc7vHig+wGOADfIAP8AELtFPm9ghtsRgwQLtlbq/QB' +
        'osBLbSZnRN3kU3QWosBEWkdu0sd0qLVm6DG72rLR0nBLmzEtlFui2BNXjwVe7CevaVevlWsDP/EOf' +
        'cFcjsSbWWP964AAAAASUVORK5CYII=';
    }
  }
}
